@if(neighborhoodService.currentNeighborhood) {
  <div class="container-fluid pt-4">
    <div class="row">

      <div class="col-12 text-secondary mb-1">
        <small><b>
          Configuración de usuarios
        </b></small>
      </div>

      <div class="col-12 bg-white px-3 rounded mb-4 py-3">
        <div class="row">

          <div class="col-12 col-md-6 mb-3">
            <label class="form-label">
              Número máximo de usuarios por predio
            </label>
            <input
              type="number"
              class="form-control"
              (keyup.enter)="update()"
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.accountsPerProperty"
              placeholder="Número máximo de usuarios por predio">
          </div>

          <div class="col-12 col-md-6 mb-3">
            <label class="form-label">
              Número máximo de dispositivos por usuario
            </label>
            <input
              type="number"
              class="form-control"
              (keyup.enter)="update()"
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.devicesPerProperty"
              placeholder="Número máximo de dispositivos por usuario">
          </div>

          <div class="col-12">
            <button
              class="btn btn-success w-100 d-flex align-items-center justify-content-center"
              (click)="update()">
              <i class="material-icons me-2">save</i>
              Guardar
            </button>
          </div>

        </div>
      </div>

      @if(authService.currentUser?.profile === 'sudo') {
        <div class="col-12 text-secondary mb-1">
          <small><b>
            Capacidad del fraccionamiento
          </b></small>
        </div>

        <div class="col-12 bg-white px-3 rounded mb-4 py-3">
          <div class="row">

            <div class="col-12 col-md-6 mb-3">
              <label class="form-label">
                Número de propiedades
              </label>
              <input
                type="number"
                class="form-control"
                (keyup.enter)="update()"
                [(ngModel)]="neighborhoodService.currentNeighborhood!.numberProperties"
                placeholder="Número de propiedades">
            </div>

            <div class="col-12 col-md-6 mb-3">
              <label class="form-label">
                Número de licencias
              </label>
              <input
                type="number"
                class="form-control"
                (keyup.enter)="update()"
                [(ngModel)]="neighborhoodService.currentNeighborhood!.licencesNumber"
                placeholder="Número de licencias">
            </div>

            <div class="col-12">
              <button
                class="btn btn-success w-100 d-flex align-items-center justify-content-center"
                (click)="update()">
                <i class="material-icons me-2">save</i>
                Guardar
              </button>
            </div>

          </div>
        </div>
      }

    </div>
  </div>
}
